import { Component } from 'preact'
import ShowMoreButton from './ShowMoreButton'
import QuickLinksList from './QuickLinksList'
import QuickLink from './QuickLink'

export default class QuickLinksContainer extends Component {
  constructor (props) {
    super()

    this.state = {
      showAll: props.showAll
    }
    this.showMoreHandler = this.showMoreHandler.bind(this)
  }

  showMoreHandler () {
    this.setState({
      showAll: !this.state.showAll
    })
  }

  render (props, state) {
    const { data, settings, itemsPerContainer, isKnowledgeBase, title } = props
    const { showAll } = state
    const customClass = isKnowledgeBase ? 'custom-knowledge-base' : 'custom-quicklink'

    if (!data.length) {
      return null
    }

    return (
      <section class={`full-width Template-brand-featured qa-quicklinks-container quicklinks-wrapper homepage-widget-wrapper ${customClass}`}>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <QuickLinksList isKnowledgeBase={isKnowledgeBase}>
              { data.map((item, idx) => <QuickLink
                item={item}
                idx={idx}
                enableBorder={settings.enableBorder}
                borderRadius={settings.borderRadius}
                isVisibleDesktop={showAll || idx < itemsPerContainer}
                isKnowledgeBase={isKnowledgeBase} />)}
            </QuickLinksList>
          </div>
        </div>
        {(data.length > itemsPerContainer && !isKnowledgeBase) &&
          <ShowMoreButton
            quickLinksLength={data.length}
            itemsPerContainer={itemsPerContainer}
            showMore={this.showMoreHandler}
            showAll={showAll} />}
      </section>
    )
  }
}
